module.exports = __webpack_public_path__ + "static/media/11.c35445f2.jpeg";